import { render, staticRenderFns } from "./ScreenSkills.vue?vue&type=template&id=ea4a0c5c&scoped=true&lang=pug"
import script from "./ScreenSkills.vue?vue&type=script&lang=ts"
export * from "./ScreenSkills.vue?vue&type=script&lang=ts"
import style0 from "./ScreenSkills.vue?vue&type=style&index=0&id=ea4a0c5c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4a0c5c",
  null
  
)

export default component.exports